import { useI18n } from 'i18n-utils'
import { Platform, PlatformKey, PlatformName } from 'platform-config'

type RadiusMap = Partial<Record<Platform, number>>

export const useContents = () => {
  const { t } = useI18n()
  const faqs = computed(() => {
    return [
      {
        title: t('{platformName} 是如何运作的？', {
          platformName: t(PlatformName),
        }),
        description: t(
          '在 {platformName}，您只需选择合适的算力套餐并完成算力费用与电费的支付，系统即会启动服务流程。矿场方将为您完成矿机配置、电力调配、运维管理等一系列技术操作，省去繁琐步骤，助您轻松开启挖矿之旅，享受一站式便捷服务与稳定收益。',
          {
            platformName: t(PlatformName),
          },
        ),
      },
      {
        title: t('{platformName} 支持哪些支付方式？', {
          platformName: t(PlatformName),
        }),
        description: t('目前，{platformName} 支持使用 USDT（ERC20） 进行支付，更多支付方式将陆续开放，敬请关注后续公告。', {
          platformName: t(PlatformName),
        }),
      },
      {
        title: t('{platformName} 所售算力对应的矿机归属权如何？', {
          platformName: t(PlatformName),
        }),
        description: t(
          '{platformName} 提供的云算力产品所对应的矿机资产归平台所有。我们为用户提供技术服务，帮助您以更低门槛接入全球算力网络。目前矿机托管于美国、老挝、埃塞俄比亚等多地合规运营的矿场，未来还将不断拓展更多电力资源优渥的地区。',
        ),
      },
      {
        title: t('{platformName} 的矿场位于哪里？', {
          platformName: t(PlatformName),
        }),
        description: t(
          '当前 {platformName} 的矿机分布于全球多个国家，包括美国、老挝、埃塞俄比亚等地。所有矿场均实现 24 小时不间断运维支持与远程监控，以保障算力在线与客户收益稳定。',
          {
            platformName: t(PlatformName),
          },
        ),
      },
      {
        title: t('购买云算力是否需要实名认证？'),
        description: t('为保障用户账户资产安全及遵守合规要求，{platformName} 要求所有用户在购买云算力前完成 KYC 实名认证流程。认证通过后，您即可进行算力购买与投入运行。', {
          platformName: t(PlatformName),
        }),
      },
      {
        title: t('云算力购买后是否支持退款？'),
        description: (
          <div>
            {t(
              '{platformName} 所有产品为预付型服务，一经购买后即开始分配算力与服务资源，因此相关费用不予退还。我们将在产品界面显著位置做出提示，建议您在下单前仔细阅读服务条款与免责声明。如有疑问，欢迎随时联系 {platformName} 客服邮箱：',
              {
                platformName: t(PlatformName),
              },
            )}
            <a href={'mailto: support@cyberleap.us'} class="link">
              support@cyberleap.us
            </a>
          </div>
        ),
      },
      {
        title: t('电费余额不足将产生什么影响？'),
        description: t('矿机运行需持续电力支持，如账户电费余额不足，将导致对应算力暂停运行，收益也将同步中止。建议您及时关注电费余额并设置自动续费，以避免收益中断。'),
      },
    ]
  })

  const radiusMap: RadiusMap = {
    [Platform.HashSpace]: 22,
  }

  const btnRadiusMap: RadiusMap = {
    [Platform.HashSpace]: 38,
  }

  const buttonRadius = computed(() => radiusMap[PlatformKey] ?? 8)

  const btnRadius = computed(() => btnRadiusMap[PlatformKey] ?? 0)

  return {
    faqs,
    btnRadius,
    buttonRadius,
  }
}
